export default __webpack_public_path__ + "static/media/km.18fb1391.svg";